import React, { useEffect, useState } from 'react';
import {
  BookOpenIcon,
  CheckCircleIcon,
  UncheckIcon,
  FileUploadIcon,
} from '../../../icons';
import { Rounded } from '../../elements/rounded';
import { downloadDocument } from '../../../transactions/download/download';

const DocumentComponent = ({ docData, docsVal, handleDocsChange }) => {
  const { actions, friendlyName, docCode, link } = docData;
  const [activeButton, setActiveButton] = useState(null);
  const [borderColor, setBorderColor] = useState('');

  useEffect(() => {
    const selectedDoc = docsVal[docData.cncode] || {};
    const selectedButton = selectedDoc[docCode.value];
    const borderColor =
      activeButton === 'rejected'
        ? 'border border-primary'
        : activeButton === 'accepted'
        ? 'border border-success'
        : '';
    setActiveButton(selectedButton);

    setBorderColor(borderColor);
  }, [docsVal, docData, docCode, activeButton]);

  return (
    <div className="flex flex-col gap-4">
      <h6>{friendlyName?.value}</h6>
      <div
        className={`document-card bg-white flex flex-col gap-4 p-4 rounded-xl ${borderColor}`}
      >
        <div className="flex justify-between gap-2">
          <div className="flex flex-col">
            <FileUploadIcon />
            <h5 className="text-darkgrey">Document.pdf</h5>
          </div>
          <button type="button" onClick={() => downloadDocument(link.value)}>
            <Rounded className="border border-fadedgrey p-3 self-center">
              <BookOpenIcon />
            </Rounded>
          </button>
        </div>
        <div className="flex justify-between border-t border-fadedgrey pt-4">
          <span className="text-body text-grenite">{docCode.label}</span>
          <span className="max-lg:font-medium h6">{docCode.value}</span>
        </div>
      </div>
      <div className="grid lg:grid-cols-2 gap-3 lg:self-end">
        {actions.map((action) => {
          const { id, label, name } = action;
          return (
            <button
              key={id}
              type="button"
              className={
                activeButton === name
                  ? 'flex gap-2 items-center justify-center btn bg-black text-secondary text-primary-button px-8'
                  : 'flex gap-2 items-center justify-center btn btn-secondary text-secondary-button px-8'
              }
              onClick={() => handleDocsChange(docData, name)}
            >
              {name === 'rejected' && (
                <UncheckIcon
                  className={
                    activeButton === name
                      ? 'w-6 h-6 stroke-primary'
                      : 'w-6 h-6 stroke-grenite'
                  }
                />
              )}
              {name === 'accepted' && (
                <CheckCircleIcon
                  className={`${
                    activeButton === name
                      ? 'stroke-[#13EF00]'
                      : 'stroke-grenite'
                  }`}
                />
              )}

              {label}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default DocumentComponent;
